import { render, staticRenderFns } from "./adv_channel_action_list.vue?vue&type=template&id=b2e85b18&scoped=true&"
import script from "./adv_channel_action_list.vue?vue&type=script&lang=js&"
export * from "./adv_channel_action_list.vue?vue&type=script&lang=js&"
import style0 from "./adv_channel_action_list.vue?vue&type=style&index=0&id=b2e85b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e85b18",
  null
  
)

export default component.exports